<template>
  <div>
    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >

    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "姓名",
          key: "userName",
        },
        {
          title: "扣分项目",
          key: "alarmTypeName",
        },
        {
          title: "车牌号",
          key: "carNo",
        },
        {
          title: "扣分",
          key: "score",
        },      
        {
          title: "扣分时间",
          key: "startTime",
    
        },{
          title: "扣分地点",
          key: "startAdd",
        },

      ],
      tableData: [],
      searchItem: {
        endTime: 0,
        startTime: 0,
        pageNumber: 1,
        pageSize: 50,
        userId: "",
      },
      total:0
    };
  },
  methods: {
    reachData(v) {
      this.searchItem.userId=v.userId;
      this.searchItem.startTime=v.startTime;
      this.searchItem.endTime=v.endTime;
      this.getList();
    },
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.report + "/assess/item",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
            console.log(res);
        
          this.total = res.data.data.total;
          var data = res.data.data.dataList;
          this.tableData = data;
        }
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/report/reportAssessDetail.vue